<template>
  <div id="coordinator-teams">
    <b-container id="coordinator-teams-table" fluid>
      <b-row class="mt-4">
        <b-col cols="5">
          <br />
          <b-col>
            <h4 class="subtitle">
              Coordinator's Current Teams ({{ teamsTable.length }})
            </h4>
            <b-form-group>
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-table
              v-cloak
              responsive
              :fields="coordinatorTeamsFields"
              :items="teamsTable"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template slot="cell(name)" slot-scope="row" v-if="teamsTable">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditTeam',
                    params: { id: row.item.team_uuid },
                  }"
                  >{{ row.item.name }}</b-link
                >
              </template>
              <template slot="cell(active)" slot-scope="row">
                <b-form-radio-group
                  :id="row.item.id.toString()"
                  :value="row.item.active"
                  v-model="row.item.active"
                  @change="updateCoordinatorTeam(row)"
                >
                  <b-form-radio :value="true">True</b-form-radio>
                  <b-form-radio :value="false">False</b-form-radio>
                </b-form-radio-group>
              </template>
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  class="delete"
                  @click.stop="deleteCoordinatorTeam(row.item)"
                  >Delete Link</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="my-1">
                <b-pagination
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-col>
        <b-col></b-col>
        <b-col cols="5">
          <div class="table-wrap">
            <br />
            <h4 class="subtitle">Add Teams</h4>
            <div>
              <router-link v-if="isAdmin" :to="{ name: 'NewTeam' }"
                >+Add Team</router-link
              >
            </div>
            <br />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CoordinatorService from "../services/CoordinatorService";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "CoordinatorTeams",
  mixins: [flash, scrollTo],
  data() {
    return {
      coordinatorId: this.$route.params.id ? this.$route.params.id : null,
      isDisabled: true,
      country: "",
      region: "",
      district: "",
      village: "",
      coordinatorTeamsFields: [
        { key: "name", label: "Name", sortable: true },
        { key: "active", label: "Active?", sortable: true },
        { key: "delete", label: "DELETE" },
      ],
      file: this.$route.path.slice(1),
      currentPage: 1,
      country: "",
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: null,
      filterSearchResults: null,
      totalRows: this.rows,
    };
  },
  methods: {
    ...mapActions({
      GET_COORDINATOR_TEAMS: "coordinators/GET_COORDINATOR_TEAMS",
      RESET_COORDINATORS_STATE: "coordinators/RESET_COORDINATORS_STATE",
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredResults(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async updateCoordinatorTeam(params) {
      const payload = await {
        id: params.item.id,
        team_id: params.item.team_id,
        team_uuid: params.item.team_uuid,
        coordinator_uuid: this.$route.params.id,
        active: !params.item.active,
      };
      await CoordinatorService.updateCoordinatorTeam(payload);
      await this.GET_COORDINATOR_TEAMS();
    },
    async addTeamToCoordinator(params) {
      const payload = await {
        team_id: params.item.team_id,
        team_uuid: params.item.team_uuid,
        coordinator_uuid: this.$route.params.id,
        active: true,
      };
      await CoordinatorService.addCoordinatorTeam(payload);
      await this.scrollTo("coordinator-teams-alert");
      await this.flashSuccess();
      await this.GET_COORDINATOR_TEAMS();
    },
    async deleteCoordinatorTeam(params) {
      const confirmDelete = confirm(
        "Are you sure you want to delete this team?"
      );
      if (confirmDelete) {
        await CoordinatorService.deleteCoordinatorTeam(params);
        await this.GET_COORDINATOR_TEAMS();
      }
    },
    stopClick(row) {},
  },
  computed: {
    teams: {
      get() {
        // add some stuff to clean this up
        return this.$store.state.coordinators.coordinatorTeams;
      },
    },
    teamsTable() {
      const teams = this.teams.map((k) => ({
        id: k.id,
        team_id: k.team_id,
        team_uuid: k.uuid,
        name: k.team_name,
        active: k.active,
      }));
      return teams;
    },
    rows() {
      return this.teams.length;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.coordinatorTeamsFields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.GET_COORDINATOR_TEAMS();
  },
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}
.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}
table th,
table tr {
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.delete {
  color: #9f020f;
  font-weight: bold;
}
</style>
